import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/products/wstandard',
      name: 'wstandard',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Wstandard.vue')
    },
    {
      path: '/products/wsimple',
      name: 'wsimple',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Wsimple.vue')
    },
    {
      path: '/products/wsafety',
      name: 'wsafety',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Wsafety.vue')
    },
    {
      path: '/products/weasy',
      name: 'weasy',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Weasy.vue')
    },
    {
      path: '/products/weco',
      name: 'weco',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Weco.vue')
    },
    {
      path: '/products/bstandard',
      name: 'bstandard',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Bstandard.vue')
    },
    {
      path: '/products/beco',
      name: 'beco',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Beco.vue')
    },
    {
      path: '/products/bsimple',
      name: 'bsimple',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Bsimple.vue')
    },
    {
      path: '/products/blight',
      name: 'blight',
      component: () => import(/* webpackChunkName: "products" */ './views/products/Blight.vue')
    },
    {
      path: '/feature',
      name: 'feature',
      component: () => import(/* webpackChunkName: "feature" */ './views/Feature.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ './views/Search.vue')
    },
    {
      path: '/color-variation',
      name: 'variation',
      component: () => import(/* webpackChunkName: "variation" */ './views/Variation.vue')
    },
    {
      path: '/concept',
      name: 'concept',
      component: () => import(/* webpackChunkName: "concept" */ './views/Concept.vue')
    }
  ]
})
